import { useState, useEffect } from 'react';
import config from '../../../config/config';
import { useNavigate } from 'react-router-dom';

export function ViewCustomer() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [chequeNo, setChequeNo] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [totalPayment, setTotalPayment] = useState(0);
  const [receivedPayment, setReceivedPayment] = useState(0);
  const [remainingPayment, setRemainingPayment] = useState(0);
  const [shareDetails, setShareDetails] = useState([]);
  const [paymentRecords, setPaymentRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [bankName, setBankName] = useState("");

  const [cashAmount, setCashAmount] = useState(0);
  const [chequeAmount, setChequeAmount] = useState(0);
  const [onlineAmount, setOnlineAmount] = useState(0);

  const userId = localStorage.getItem('userId');

  const filteredCustomers = customers.filter(customer => {
    const matchesSearch = customer.customer_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.customer_id.toString().includes(searchTerm);

    const isPending = customer.payment_status === 'pending' ||
      customer.payment_status === 'partially_paid';

    return matchesSearch && isPending;
  });

  const handlePaymentClick = async (customer) => {
    try {
      const token = localStorage.getItem('token');

      // 1. Share Details Fetching
      const shareResponse = await fetch(`${config.baseUrl}/api/moderator/get-share-price/${customer.customer_id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!shareResponse.ok) throw new Error('Failed to fetch share details');
      const shareData = await shareResponse.json();

      // 2. Payment Records Fetching
      const paymentResponse = await fetch(`${config.baseUrl}/api/moderator/payment-records/${customer.customer_id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!paymentResponse.ok) throw new Error('Failed to fetch payment records');
      const paymentData = await paymentResponse.json();

      setPaymentRecords(paymentData);

      // 3. Calculation Logic
      const totalReceivedSoFar = paymentData.reduce((sum, payment) => sum + Number(payment.received_payment), 0);
      const balanceRemaining = shareData.totalAmount - totalReceivedSoFar;

      // FIX: Total payable hamesha bacha hua balance hona chahiye
      setTotalPayment(balanceRemaining);

      // FIX: Received payment ko 0 rakhein taake user enter kare
      setReceivedPayment(0);

      // FIX: Remaining payment shuru mein total balance ke barabar dikhaye
      setRemainingPayment(balanceRemaining);

      setShareDetails(shareData.shareDetails);
      setSelectedCustomer(customer);
      setShowPaymentModal(true);
    } catch (error) {
      console.error('Error:', error);
      alert('Error: ' + error.message);
    }
  };

  const handleSubmitPayment = async () => {
    if (!paymentMethod) {
      alert("Please select a payment method.");
      return;
    }

    const amount = Number(receivedPayment);
    const isZero = amount === 0;
    const isFullPayment = amount === Number(totalPayment);

    if (!isZero && !isFullPayment) {
      alert("Error: You can only enter 0 or the full payment amount.");
      return;
    }

    // if (receivedPayment <= 0) {
    //   alert("Received amount must be greater than zero.");
    //   return;
    // }

    // Payment Method specific validations
    if (paymentMethod === 'cheque') {
      if (!chequeNo.trim() || !bankName.trim()) {
        alert("Please enter both Cheque Number and Bank Name.");
        return;
      }
    }

    if (paymentMethod === 'online') {
      if (!transactionId.trim()) {
        alert("Please enter the Transaction ID / Reference number.");
        return;
      }
    }

    // Safety check: total received check
    if (receivedPayment > totalPayment) {
      alert("Received payment cannot exceed the total payable amount.");
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const isFullyPaid = Number(receivedPayment) >= Number(totalPayment);
      const paymentStatus = isFullyPaid ? 'paid' : 'partially_paid';
      const paymentData = {
        customerId: selectedCustomer.customer_id,
        paymentMethod,
        totalPayment,
        receivedPayment,
        remainingPayment,
        paymentStatus,
        userId,
        splitAmounts: {
          cashAmount: paymentMethod.includes('cash') ? cashAmount : 0,
          chequeAmount: paymentMethod.includes('cheque') ? chequeAmount : 0,
          onlineAmount: paymentMethod.includes('online') ? onlineAmount : 0
        },
        ...(paymentMethod === 'cheque' && { chequeNo, bankName }),
        ...(paymentMethod === 'online' && { transactionId })
      };

      const response = await fetch(`${config.baseUrl}/api/moderator/submit-payment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(paymentData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit');
      }
      setShowPaymentModal(false);
      resetForm();
      window.location.href = `/moderator/booking/${selectedCustomer.customer_id}`;
    } catch (error) {
      alert(error.message);
    }
  };

  const resetForm = () => {
    setPaymentMethod(''); setChequeNo(''); setTransactionId(''); setBankName('');
    setReceivedPayment(0); setRemainingPayment(0);
  };

  const fetchCustomers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseUrl}/api/moderator/customers`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setCustomers(data.map(c => ({ ...c, payment_status: c.payment_status || 'pending' })));
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchCustomers(); }, []);

  return (


    <main className="flex-1">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-extrabold text-gray-800 tracking-tight">Customer Directory</h1>
          <div className="bg-white px-4 py-2 rounded-lg shadow-sm border text-sm font-medium text-gray-500">
            Total: {customers.length} Customers
          </div>
        </div>

        {/* Search Bar */}
        <div className="relative mb-6">
          <input
            type="text"
            placeholder="Search by name or ID..."
            className="w-full pl-12 pr-4 py-3 bg-white border border-gray-200 rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 outline-none transition-all"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <svg className="absolute left-4 top-3.5 h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        ) : (
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
            <table className="w-full text-left">
              <thead className="bg-indigo-800 text-white border-b border-gray-100">
                <tr className='text-center'>
                  <th className="px-6 py-4 text-sm font-bold uppercase">ID</th>
                  <th className="px-6 py-4 text-sm font-bold uppercase">Customer Name</th>
                  <th className="px-6 py-4 text-sm font-bold uppercase">Status</th>
                  <th className="px-6 py-4 text-sm font-bold uppercase">Date</th>
                  <th className="px-6 py-4 text-sm font-bold uppercase">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50 text-center">
                {filteredCustomers.map((customer) => (
                  <tr key={customer.customer_id} className="hover:bg-blue-50/50 transition-colors">
                    <td className="px-6 py-4 font-mono text-blue-600 font-bold">#{customer.customer_id}</td>
                    <td className="px-6 py-4 font-semibold text-gray-800">{customer.customer_name}</td>
                    <td className="px-6 py-4 text-center">
                      <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${customer.payment_status === 'paid' ? 'bg-green-100 text-green-700' :
                        customer.payment_status === 'partially_paid' ? 'bg-amber-100 text-amber-700' : 'bg-red-100 text-red-700'
                        }`}>
                        {customer.payment_status.replace('_', ' ')}
                      </span>
                    </td>
                    <td className="px-6 py-4 font-semibold text-gray-800">
                      {new Date(customer.created_at).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      })}
                      <span className="text-gray-400 ml-2">
                        {new Date(customer.created_at).toLocaleTimeString('en-US', {
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right">
                      {customer.payment_status !== 'paid' && (
                        <button
                          onClick={() => handlePaymentClick(customer)}
                          className="bg-indigo-900 hover:bg-blue-700 text-white px-5 py-2 rounded-lg text-sm font-bold shadow-md transition-all active:scale-95"
                        >
                          Pay Now
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* --- MODERN PAYMENT MODAL --- */}
      {showPaymentModal && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">

            <div className="p-6 border-b flex justify-between items-center bg-gray-50">
              <h2 className="text-2xl font-black text-gray-800 tracking-tight">Finalize Payment</h2>
              <button onClick={() => { setShowPaymentModal(false); resetForm(); }} className="text-gray-400 hover:text-gray-600 transition-colors">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto space-y-6">
              {/* Info Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-blue-50 p-4 rounded-2xl border border-blue-100">
                  <p className="text-xs font-bold text-blue-500 uppercase mb-1">Total Payable</p>
                  <p className="text-2xl font-black text-blue-700">Rs. {totalPayment}</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-2xl border border-gray-100">
                  <p className="text-xs font-bold text-gray-500 uppercase mb-1">Customer</p>
                  <p className="text-lg font-bold text-gray-700 truncate">{selectedCustomer?.customer_name}</p>
                </div>
              </div>

              {/* Share Summary */}
              <div className="border rounded-2xl overflow-hidden">
                <div className="bg-gray-100 px-4 py-2 text-xs font-bold text-gray-600 uppercase">Share Breakdown</div>
                <div className="divide-y max-h-40 overflow-y-auto bg-white">
                  {shareDetails?.map((share, i) => (
                    <div key={i} className="px-4 py-3 flex justify-between items-center text-sm">
                      <span>{share.share_count}x {share.cat_name} ({share.subcat_name})</span>
                      <span className="font-bold text-gray-700">Rs. {share.total_amount}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Form Fields */}
              <div className="space-y-4 pt-4 border-t">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-1">
                    <label className="text-sm font-bold text-gray-700 ml-1">Received Amount</label>
                    <input
                      type="number"
                      className={`w-full p-3 border rounded-xl outline-none font-bold text-lg 
    ${(receivedPayment !== 0 && receivedPayment !== totalPayment) ? 'bg-red-50 border-red-500' : 'bg-gray-50'}`} value={receivedPayment || ''}
                      onChange={(e) => {
                        const val = e.target.value === '' ? 0 : parseFloat(e.target.value);
                        setReceivedPayment(val);
                        setRemainingPayment(totalPayment - val);
                      }}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="text-sm font-bold text-gray-700 ml-1 text-red-500">Balance Due</label>
                    <div className="w-full p-3 bg-red-50 border border-red-100 rounded-xl font-bold text-lg text-red-600">
                      Rs. {remainingPayment}
                    </div>
                  </div>
                </div>

                <div className="space-y-1">
                  <label className="text-sm font-bold text-gray-700 ml-1">Payment Method</label>
                  <select
                    className="w-full p-3 bg-white border rounded-xl focus:ring-2 focus:ring-blue-500 outline-none font-semibold text-gray-700 cursor-pointer"
                    value={paymentMethod}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                  >
                    <option value="">Select Option</option>
                    <option value="cash">Cash</option>
                    <option value="cheque">Cheque</option>
                    <option value="online">Online</option>
                    <option value="cash_online">Cash + Online</option>
                    <option value="cash_cheque">Cash + Cheque</option>
                    <option value="cheque_online">Cheque + Online</option>
                  </select>
                </div>

                {/* Hybrid Amount Inputs Logic */}
                {(paymentMethod === 'cash_cheque' || paymentMethod === 'cash_online' || paymentMethod === 'cheque_online') && (
                  <div className="grid grid-cols-2 gap-4 p-4 bg-gray-50 rounded-2xl animate-in slide-in-from-top-2 duration-300">
                    {paymentMethod.includes('cash') && (
                      <div>
                        <label className="text-[10px] font-black uppercase text-gray-400">Cash Amount</label>
                        <input type="number" value={cashAmount || ''} onChange={(e) => setCashAmount(Number(e.target.value))} className="w-full bg-white border-b-2 p-1 outline-none font-bold" />
                      </div>
                    )}
                    {paymentMethod.includes('cheque') && (
                      <div>
                        <label className="text-[10px] font-black uppercase text-gray-400">Cheque Amount</label>
                        <input type="number" value={chequeAmount || ''} onChange={(e) => setChequeAmount(Number(e.target.value))} className="w-full bg-white border-b-2 p-1 outline-none font-bold" />
                      </div>
                    )}
                    {paymentMethod.includes('online') && (
                      <div>
                        <label className="text-[10px] font-black uppercase text-gray-400">Online Amount</label>
                        <input type="number" value={onlineAmount || ''} onChange={(e) => setOnlineAmount(Number(e.target.value))} className="w-full bg-white border-b-2 p-1 outline-none font-bold" />
                      </div>
                    )}
                  </div>
                )}

                {/* Cheque & Online Details (Ye ab bhi waisa he kaam karega) */}
                {paymentMethod.includes('cheque') && (
                  <div className="grid grid-cols-2 gap-4 p-4 bg-gray-50 rounded-2xl">
                    <div>
                      <label className="text-[10px] font-black uppercase text-gray-400">Cheque #</label>
                      <input type="text" value={chequeNo} onChange={(e) => setChequeNo(e.target.value)} className="w-full bg-white border-b-2 p-1 outline-none font-bold" />
                    </div>
                    <div>
                      <label className="text-[10px] font-black uppercase text-gray-400">Bank Name</label>
                      <input type="text" value={bankName} onChange={(e) => setBankName(e.target.value)} className="w-full bg-white border-b-2 p-1 outline-none font-bold" />
                    </div>
                  </div>
                )}

                {paymentMethod.includes('online') && (
                  <div className="p-4 bg-blue-50 rounded-2xl">
                    <label className="text-[10px] font-black uppercase text-blue-400">Transaction ID</label>
                    <input type="text" value={transactionId} onChange={(e) => setTransactionId(e.target.value)} className="w-full bg-transparent border-b-2 border-blue-200 p-1 outline-none font-bold text-blue-700" />
                  </div>
                )}

              </div>
            </div>

            <div className="p-6 bg-gray-50 border-t flex gap-3">
              <button onClick={() => { setShowPaymentModal(false); resetForm(); }} className="flex-1 py-3 font-bold text-gray-500 hover:text-gray-700 transition-colors">Cancel</button>
              <button
                onClick={handleSubmitPayment}
                className="flex-[2] bg-blue-600 hover:bg-blue-700 text-white py-4 rounded-2xl font-black shadow-lg shadow-blue-200 transition-all active:scale-95"
              >
                CONFIRM & PRINT RECEIPT
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}